import { useState } from 'react';

export const useToggle = () => {
  const [ show, setShow ] = useState(false);

  const onClick = () => {
    setShow(!show);
  };

  return {
    show,
    onClick
  };
};